import React, { FC, useCallback } from 'react';
import { Keywords } from 'src/shared/Keywords';
import ProfileHeader from './components/ProfileHeader';
import { useTranslation } from 'react-i18next';
import { SearchProfileColor } from 'src/helpers/constants';
import { useUpdateTerms } from '../../hooks';

interface IProps {
  color: SearchProfileColor;
  id: string;
  terms: string[];
  title: string;
  existingKeywords: string[];
}

export const SearchProfile: FC<IProps> = props => {
  const { color, title, terms, id, existingKeywords } = props;
  const { t } = useTranslation();

  const [updateKeywords, { loading }] = useUpdateTerms();

  const onChange = useCallback(
    (updatedTerms: string[]) => {
      updateKeywords({
        searchProfileId: id,
        searchProfileTitle: title,
        terms: updatedTerms,
        prevTerms: terms
      });
    },
    [id, terms, title, updateKeywords]
  );

  return (
    <>
      <ProfileHeader loading={loading} color={color} id={id} title={title} />
      <Keywords
        label={t('Common.addKeywordsFromPreview')}
        disabled={false}
        keywords={terms}
        onChange={onChange}
        color={color}
        existingKeywords={existingKeywords}
      />
    </>
  );
};

export default SearchProfile;
